const STORAGE_KEY = "pms_h5_mode";
export const H5_MODE_EVENT = "pms:h5-mode-change";
let forcedH5 = false;

export function isH5Mode() {
  return forcedH5;
}

function setH5Mode(enabled: boolean) {
  const changed = enabled !== forcedH5;
  forcedH5 = enabled;
  document.documentElement.toggleAttribute("data-h5", enabled);
  try {
    if (enabled) window.sessionStorage.setItem(STORAGE_KEY, "true");
    else window.sessionStorage.removeItem(STORAGE_KEY);
  } catch { /* The URL remains usable when WebView storage is unavailable. */ }
  if (changed) window.dispatchEvent(new Event(H5_MODE_EVENT));
}

/** Only an explicit, unambiguous value changes the current visit's mode. */
export function applyH5Query(value: unknown) {
  if (value === "true") setH5Mode(true);
  else if (value === "false" || value === "auto") setH5Mode(false);
}

/** Run before Router's initial redirect, which may discard the entry query. */
export function initializeH5Mode() {
  let stored = false;
  try { stored = window.sessionStorage.getItem(STORAGE_KEY) === "true"; }
  catch { /* Some embedded browsers disable storage. */ }
  setH5Mode(stored);
  const values = new URLSearchParams(window.location.search).getAll("h5");
  if (values.length === 1) applyH5Query(values[0]);
}

/** Carry the mode through same-origin full navigations, including OAuth. */
export function withH5Url(value: string) {
  if (!forcedH5) return value;
  const url = new URL(value, window.location.href);
  if (url.origin !== window.location.origin) return value;
  if (!url.searchParams.has("h5")) url.searchParams.set("h5", "true");
  return `${url.pathname}${url.search}${url.hash}`;
}
